var _div;
import { Skeleton } from '@crehana/compass.ui/v2';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SkeletonList = function SkeletonList() {
  return _div || (_div = /*#__PURE__*/_jsxs("div", {
    className: "tw-space-y-1.6 tw-rounded-[20px] tw-p-2.4 tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-02",
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-pb-1.6 tw-border-b-[3px] tw-border-solid tw-border-neutral-light-300 dark:tw-border-neutral-dark-500",
      children: /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-16 tw-h-1.2"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-p-1.6 tw-flex tw-flex-col sm:tw-flex-row tw-gap-2",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "tw-rounded-0.8 tw-w-full sm:tw-w-[145px] tw-h-[88px]"
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-justify-between tw-gap-1",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-28 tw-h-2.4 tw-rounded-[32px]"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-11.2 tw-h-2 tw-rounded-[32px]"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-[450px] tw-h-2 tw-rounded-[32px]"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-p-1.6 tw-flex tw-flex-col sm:tw-flex-row tw-gap-2",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "tw-rounded-0.8 tw-w-full sm:tw-w-[145px] tw-h-[88px]"
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-justify-between tw-gap-1",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-28 tw-h-2.4 tw-rounded-[32px]"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-11.2 tw-h-2 tw-rounded-[32px]"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-[450px] tw-h-2 tw-rounded-[32px]"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-p-1.6 tw-flex tw-flex-col sm:tw-flex-row tw-gap-2",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "tw-rounded-0.8 tw-w-full sm:tw-w-[145px] tw-h-[88px]"
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-justify-between tw-gap-1",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-28 tw-h-2.4 tw-rounded-[32px]"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-11.2 tw-h-2 tw-rounded-[32px]"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-[450px] tw-h-2 tw-rounded-[32px]"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-p-1.6 tw-flex tw-flex-col sm:tw-flex-row tw-gap-2",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "tw-rounded-0.8 tw-w-full sm:tw-w-[145px] tw-h-[88px]"
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-justify-between tw-gap-1",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-28 tw-h-2.4 tw-rounded-[32px]"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-11.2 tw-h-2 tw-rounded-[32px]"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full sm:tw-w-[450px] tw-h-2 tw-rounded-[32px]"
        })]
      })]
    })]
  }));
};